export class DisconnectRestoreAccountResponse {
    'restoreAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccount",
            "baseName": "restoreAccount",
            "type": "RestoreAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DisconnectRestoreAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
